/* Temporary containment for inconsistent Shopify locale routes (2026-09-28). */
(() => {
  const config = document.currentScript;
  if (!config) return;
  const asRoot = (value) => '/' + String(value || '').replace(/^\/+|\/+$/g, '') + '/';
  const expected = asRoot(config.dataset.localeRoot).replace('//', '/');
  const actual = asRoot(config.dataset.shopifyRoot).replace('//', '/');
  if (expected === actual || !/^\/(?:[a-zA-Z0-9-]+\/)?$/.test(expected) || !/^\/(?:[a-zA-Z0-9-]+\/)?$/.test(actual)) return;

  const normalize = (value) => {
    if (!value || /^(?:#|mailto:|tel:|javascript:)/i.test(value)) return value;
    let url;
    try { url = new window.URL(value, window.location.href); } catch { return value; }
    if (url.origin !== window.location.origin || !/^https?:$/.test(url.protocol)) return value;
    const path = url.pathname;
    const isRoot = path === actual || path === actual.slice(0, -1);
    if (!isRoot && !path.startsWith(actual)) return value;
    const rest = isRoot ? '' : path.slice(actual.length);
    if (rest && !/^(?:pages|products|collections|blogs|cart|search|account|recommendations|localization)(?:[/.]|$)/.test(rest)) return value;
    url.pathname = expected + rest;
    return value.startsWith('/') && !value.startsWith('//') ? url.pathname + url.search + url.hash : url.href;
  };
  const selector = 'a[href], form[action], [data-url], [data-root-url], [data-search-url]';
  const attributes = ['href', 'action', 'data-url', 'data-root-url', 'data-search-url'];
  const fixElement = (element) => {
    // Explicit language choices must keep their destination.
    if (element.hasAttribute('hreflang')) return;
    for (const attribute of attributes) {
      if (!element.hasAttribute(attribute)) continue;
      const before = element.getAttribute(attribute);
      const after = normalize(before);
      if (after !== before) element.setAttribute(attribute, after);
    }
  };
  const scan = (root) => {
    if (root.nodeType === 1 && root.matches(selector)) fixElement(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(fixElement);
  };
  const fixRoutes = () => {
    if (window.Shopify?.routes) window.Shopify.routes.root = expected;
    if (window.routes) {
      for (const key of Object.keys(window.routes)) {
        if (typeof window.routes[key] === 'string') window.routes[key] = normalize(window.routes[key]);
      }
    }
  };
  fixRoutes();
  scan(document);
  new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'attributes') fixElement(record.target);
      else record.addedNodes.forEach(scan);
    }
  }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: attributes });
  document.addEventListener('DOMContentLoaded', fixRoutes, { once: true });
})();
